import type { FaireThemeEntity } from "../../entity_types/theme";

export const polished_and_professional_essentials: FaireThemeEntity = {
  token: "polished-and-professional-essentials",
  type: "theme",
  name: "Polished & Professional Essentials",
  description: "Sophisticated blazers and formal dresses for career-focused or occasion-seeking customers.",
  teaser: "Blazers and dresses to complete the wardrobe for your Fayetteville clientele.",
  detail: "You already stock bodysuits and cardigans -- structured blazers and dressy silhouettes complete the wardrobe. Based on your multiple recent searches for women's dressy dresses and blazers and formal dresses.",
  bgColor: "#D4EBD4",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_bzxqedpmj7",
    "p_f69nuz9cf3",
    "p_n6zqaptsrg",
    "p_n6swtztaac",
    "p_vgq5x8ec86",
    "p_baztwggcve",
    "p_us4pgy2uur",
    "p_rrayjfdn6c",
    "p_48ynqpssg5",
    "p_evgmk5wjcu",
    "p_8m6us3d68s",
    "p_gn4gb796n4",
    "p_r7tdbzj6um",
    "p_gt6p2sq5r2",
    "p_28jsmgwknq",
    "p_bb425js7uh",
    "p_eajrmwsfd7",
    "p_hxer2rczw3",
    "p_m9h4mzxc52",
    "p_emm3sbjp43",
    "p_9ajfbs3s5c",
    "p_nvymaseqg2",
    "p_gycxdwg4hq",
    "p_7qfb7pfqbm",
    "p_em8mh2xxjn",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
